import { render, staticRenderFns } from "./ProductBrochureTreeDetail.vue?vue&type=template&id=b5903b28&scoped=true&"
import script from "./ProductBrochureTreeDetail.vue?vue&type=script&lang=js&"
export * from "./ProductBrochureTreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5903b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5903b28')) {
      api.createRecord('b5903b28', component.options)
    } else {
      api.reload('b5903b28', component.options)
    }
    module.hot.accept("./ProductBrochureTreeDetail.vue?vue&type=template&id=b5903b28&scoped=true&", function () {
      api.rerender('b5903b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/ProductBrochure/ProductBrochureTreeDetail.vue"
export default component.exports